import React, { useState, useEffect, useContext } from "react";

import MainButton from "../common/MainButton";
import MainTitle from "../common/MainTitle";

import DataTable from "./StaffList";

import lbl from "../../data/Labels.json";
import db from "../../services/query";

import {PopUpContext} from "../../contexts/popUpContext";
import Filter from "./StaffFilter";

const Staff = () => {
  const [data, setData] = useState([]);
  const { togglePopUp, popUp } = useContext(PopUpContext);

  useEffect(() => {
    const ac = new AbortController();

    requestData({});

    return () => ac.abort();
  }, [popUp]);

  const requestData = async (p = {}) => {
    try {
      let {
        keyword: staff_name,
        staff_phone,
        gender_id,
        position_id,
        section_id,
        aria_id,
        user_status,
        page,
      } = p;

      let query = "staff?";

      if (page) query += `&page=${page}`;
      if (staff_name) query += `&staff_name=${staff_name}`;
      if (staff_phone) query += `&staff_phone=${staff_phone}`;
      if (gender_id) query += `&gender_id=${gender_id}`;
      if (position_id) query += `&position_id=${position_id}`;
      if (section_id) query += `&section_id=${section_id}`;
      if (aria_id) query += `&aria_id=${aria_id}`;
      if (user_status) query += `&user_status=${user_status}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainTitle title={lbl.StaffList} />
        </div>
        <div className="center-content">
          <Filter query={requestData} hasFilter={true}/>
        </div>
        <div className="left-content">
          <MainButton
              type="add"
              title={lbl.AddStaff}
              handleClick={() => togglePopUp({ form: "staff-form" })}
          />
        </div>
      </div>
      <div className="main-content-body pagination">
        <DataTable data={data?.data} />
      </div>
    </div>
  );
};

export default Staff;
